import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#f58020',
        secondary: '#888E90',
        accent: '#f58020'
      },
    },
  },
})
